<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
    >
        <rect width="21.6" height="21.6" rx="4" fill="#635BFF" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.95663 8.39638C9.95663 7.88878 10.3724 7.68897 11.0636 7.68897C12.0572 7.68897 13.31 7.99137 14.3036 8.52597V5.45877C13.2182 5.02677 12.149 4.85938 11.069 4.85938C8.41763 4.85938 6.65723 6.24177 6.65723 8.55297C6.65723 12.1548 11.6198 11.5824 11.6198 13.1376C11.6198 13.737 11.096 13.9314 10.367 13.9314C9.28163 13.9314 7.89923 13.4886 6.80303 12.8892V15.9942C8.01803 16.518 9.24383 16.7394 10.367 16.7394C13.0832 16.7394 14.9516 15.3948 14.9516 13.0566C14.93 9.16858 9.95663 9.85978 9.95663 8.39638Z"
            fill="white"
        />
    </svg>
</template>
